<form class="auth-register-form mt-2" [formGroup]="registerForm" (ngSubmit)="onSubmitReg()">
  <div class="row">
    <div class="col-12">
      <div class="form-group">
        <label for="register-role" class="form-label">Register user as a</label>
        <select formControlName="role" (change)="roleChanged()" class="form-control">
          <option [value]="0" disabled selected>Select a User Type</option>
          <option *ngFor="let role of signUpRoles" [ngValue]="role.id">
            {{ role.role }}
          </option>
        </select>
        <p *ngIf="registerForm.get('role').value === 30" class="form-label font-small-3">
          Access unlimited Quizzes, Video lessons, Exam questions, Topical notes and competitive Beewiz contests.
        </p>
        <p *ngIf="registerForm.get('role').value === 60" class="form-label font-small-3">
          Monitor and track your child's learning progress on Zeraki Learning.
        </p>
      </div>
    </div>

    <div class="col-12">
      <div class="form-group">
        <label for="register-name" class="form-label">Name</label>
        <input
          type="text" formControlName="name" class="form-control"
          placeholder="Enter your name in full" aria-describedby="register-name" tabindex="1"
          autofocus [ngClass]="{ 'is-invalid': r_submitted && rf.name.errors }" />
        <div *ngIf="r_submitted && rf.name.errors" class="invalid-feedback">
          <div *ngIf="rf.name.errors.required">Name is required</div>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="form-group">
        <label for="register-phoneNumber" class="form-label">Phone Number</label>
        <input
          type="text" formControlName="phone" class="form-control" placeholder="0700111222"
          aria-describedby="register-phoneNumber" tabindex="2"
          [ngClass]="{ 'is-invalid': r_submitted && rf.phone.errors }" />
        <div *ngIf="r_submitted && rf.phone.errors" class="invalid-feedback">
          <div *ngIf="rf.phone.errors.required">Phone Number is required</div>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="form-group">
        <label for="register-email" class="form-label">
          Email <span class="text-muted" style="font-size: small">(Optional)</span>
        </label>
        <input
          type="email" id="register-email" formControlName="email" class="form-control"
          placeholder="xyz@email.com" aria-describedby="register-email" tabindex="2" />
      </div>
    </div>

    <!-- curriculum -->
    <div class="col-12" *ngIf="registerForm.get('role').value === 30">
      <div class="form-group">
        <label for="educationSystem" class="form-label">National Curriculum</label>
        <select
          formControlName="educationSystem" class="form-control"
          [class.error]="r_submitted && rf.educationSystem.invalid"
          aria-describedby="educationSystem"
          [ngClass]="{ 'd-block': r_submitted && rf.educationSystem.errors }">
          <option value="" disabled selected>Select your curriculum</option>
          <option *ngFor="let curriculum of ['KCSE', 'CBC']" [ngValue]="curriculum">
            {{ curriculum }}
          </option>
        </select>
        <div *ngIf="r_submitted && rf.educationSystem.errors" class="invalid-feedback">
          <div *ngIf="rf.educationSystem.errors.required">Curriculum is required</div>
        </div>
      </div>
    </div>

    <!-- grade -->
    <div class="col-12" *ngIf="registerForm.get('educationSystem')?.value === 'CBC'">
      <div class="form-group">
        <label for="grade" class="form-label">Grade</label>
        <select
          formControlName="grade" class="form-control"
          [class.error]="r_submitted && rf.grade.invalid" aria-describedby="grade"
          [ngClass]="{ 'd-block': r_submitted && rf.grade.errors }">
          <option value="" disabled selected>Select a Grade</option>
          <option *ngFor="let grade of cbcGrades" [ngValue]="grade.gradeId">
            {{ grade.gradeName }}
          </option>
        </select>
        <div *ngIf="r_submitted && rf.grade.errors" class="invalid-feedback">
          <div *ngIf="rf.grade.errors.required">Grade is required</div>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="form-group" *ngIf="rf.role.value">
        <label for="register-password" class="form-label">Password</label>
        <div class="input-group input-group-merge form-password-toggle">
          <input
            [type]="passwordTextType ? 'text' : 'password'" formControlName="password"
            class="form-control form-control-merge" placeholder="············"
            aria-describedby="register-password" tabindex="3"
            [ngClass]="{ 'is-invalid error': r_submitted && rf.password.errors }" />
          <div class="input-group-append">
            <span class="input-group-text cursor-pointer">
              <i class="feather font-small-4"
                [ngClass]="{ 'icon-eye-off': passwordTextType, 'icon-eye': !passwordTextType }"
                (click)="togglePasswordTextType()"></i>
            </span>
          </div>
        </div>
        <div *ngIf="r_submitted && rf.password.errors" class="invalid-feedback"
          [ngClass]="{ 'd-block': r_submitted && rf.password.errors }">
          <div *ngIf="rf.password.errors.required">Password is required</div>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="form-group" *ngIf="rf.role.value">
        <label for="register-confirmPassword" class="form-label">Re-enter Password</label>
        <div class="input-group input-group-merge form-password-toggle">
          <input
            [type]="passwordTextType2 ? 'text' : 'password'" formControlName="confirmPassword"
            class="form-control form-control-merge" placeholder="············"
            aria-describedby="register-confirmPassword" tabindex="3"
            [ngClass]="{ 'is-invalid error': r_submitted && rf.confirmPassword.errors }" />
          <div class="input-group-append">
            <span class="input-group-text cursor-pointer">
              <i class="feather font-small-4"
                [ngClass]="{ 'icon-eye-off': passwordTextType2, 'icon-eye': !passwordTextType2 }"
                (click)="togglePasswordTextType2()"></i>
            </span>
          </div>
        </div>
        <div
          *ngIf="r_submitted && (rf.confirmPassword.errors || registerForm.errors)"
          class="invalid-feedback"
          [ngClass]="{ 'd-block': r_submitted && (rf.confirmPassword.errors || registerForm.errors) }">
          <div *ngIf="rf.confirmPassword.errors?.required">Password required</div>
          <div *ngIf="registerForm.errors?.noMatch">Password does not match</div>
        </div>
      </div>
    </div>
  </div>

  <app-terms-and-conditions (childMethodEvt)="getAcceptedTermsStatus($event)"></app-terms-and-conditions>

  <button [disabled]="loading || !agreedToTerms" class="btn btn-primary btn-block" tabindex="5" rippleEffect>
    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>Sign up
  </button>
</form>